import MagneticButton from '../components/MagneticButton';
import { useDocumentMeta } from '../lib/useDocumentMeta';

export default function Contact() {
  useDocumentMeta({
    title: 'Contact — Samia Systems',
    description: 'Reach Samia Systems Limited at info@samiasystems.com.',
  });
  return (
    <>
      <section className="grain relative bg-black px-6 pb-20 pt-40">
        <div className="container-x">
          <p className="label mb-6 inline-flex items-center gap-3">
            <span className="h-px w-10 bg-gold" />
            Contact
          </p>
          <h1 className="max-w-4xl font-display text-hero font-light text-white text-balance">
            One inbox. Reviewed daily.
          </h1>
        </div>
      </section>

      <section className="bg-black pb-32">
        <div className="container-x grid gap-16 md:grid-cols-2">
          <div>
            <p className="label mb-3">Email</p>
            <a
              href="mailto:info@samiasystems.com"
              className="font-display text-3xl font-light text-white transition-colors hover:text-gold"
            >
              info@samiasystems.com
            </a>

            <p className="label mb-3 mt-12">Registered</p>
            <p className="font-sans text-body text-white/85">
              Samia Systems Limited
              <br />
              United Kingdom
            </p>
          </div>

          <div>
            <p className="label mb-3">Fastest path</p>
            <p className="font-sans text-body text-white/85">
              For project enquiries, the fastest path is the Diagnostic call —
              it's the format we use to scope every engagement.
            </p>
            <div className="mt-8">
              <MagneticButton to="/book">Book a Diagnostic</MagneticButton>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
